var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    { attrs: { "has-fixed-group": _vm.hasFixedGroup, nav: _vm.nav } },
    [
      _vm._t("breadcrumbs"),
      _vm._v(" "),
      _vm._t("alt-header"),
      _vm._v(" "),
      _c("header", { attrs: { id: "content__header" } }, [_vm._t("header")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("fieldset", { staticClass: "toolbar__filters" }, [
          _c("div", { staticClass: "flex-fix" }, [_vm._t("filters")], 2),
        ]),
        _vm._v(" "),
        _c("fieldset", { staticClass: "toolbar__search" }, [
          _c("div", { staticClass: "flex-fix" }, [_vm._t("search")], 2),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }